import { json } from "stream/consumers";
import { ChatMessage } from "../Chats/ChatMessage"
import { IChatMessage, IChatMessageFragment, IFileUpload } from "Utils/Interfaces";
import { __ajax } from "../AJAX/ajax";
import Pusher from 'pusher-js';
import { AppState } from 'Utils/Enums';
import * as PusherTypes from 'pusher-js';
import { __chats } from "../Chats/Chats";
import { __utils } from "Utils/Utils";
import { __callbacks } from "Utils/Callbacks/Callback";
import { __chatQueue } from "Utils/ChatQueue/ChatQueue";
import { ChatMessageFragment } from "Utils/Chats/ChatMessageFragment";
import { MsgReceive } from "Utils/Explorer/MsgReceive";
import { usePusher } from "@harelpls/use-pusher";
import { __sb } from "Utils/SB/sb";

class pusherRoot {
    private APP_KEY = "7b2eee4c1e21137a3721";
    private APP_CLUSTER = "us3";
    private pusherInstance = new Pusher("7b2eee4c1e21137a3721", {
        cluster: "us3"
    })

    public createChannel(chatId: String): string {

        //console.log('PUSHER createChannel: ', chatId);

        // First we are going to unsubscribe from the channel: 
        this.pusherInstance.unsubscribe(chatId as string);

        // Now that we have unsubscribed from the channel we subscribe. 
        // The purpose behind this is that there is no real way to check if a subscription is active
        // If we have multiple subscriptions to the same channel then multiple messages will show.     

        const channel = this.pusherInstance.subscribe(chatId as string);
        channel?.unbind_all();
        channel?.bind('new-message', this.addMessage);
        channel?.bind('new-message-chunk', this.addMessageChunk);
        channel?.bind('new-message-read', this.setMessageRead);

        return "";

    }

    public decodeHTMLEntities(text: string): string {
        var entities = [
            ['amp', '&'],
            ['apos', '\''],
            ['#x27', '\''],
            ['#x2F', '/'],
            ['#39', '\''],
            ['#47', '/'],
            ['lt', '<'],
            ['gt', '>'],
            ['nbsp', ' '],
            ['quot', '"']
        ];

        for (var i = 0, max = entities.length; i < max; ++i)
            text = text.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);

        return text;
    }

    public addMessage(data: any) {

        var messageNum: number | undefined = __chats.getLastMessageNo(data.chatId);

        messageNum = messageNum as number + 1;

        new MsgReceive({
            chatId: data.chatId,
            userId: data.senderId,   // must be a Unique ID for every user
            userName: data.snedername,
            userPhoto: data.senderImage,
            fragment: false,
            text: data.message
        });

        __sb.setMessageRead(data.chatId);
    }

    public addMessageChunk(data: any) {

        if (localStorage.getItem(data.chatId) === null) {
            localStorage.setItem(data.chatId, data.message);
        }
        else {
            localStorage.setItem(data.chatId, localStorage.getItem(data.chatId) + data.message);
        }

        if (data.totalChunks === data.chunkNumber) {

            var completeMessage = localStorage.getItem(data.chatId);

            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(completeMessage || '', 'text/html');

            var imageNodes = htmlDoc.getElementsByTagName('img');
            for (var i = 0; i < imageNodes.length; i++) {
                imageNodes[i].setAttribute("onCLick", "var image = new Image(); image.src = '" + imageNodes[i].src + "'; var w = window.open(''); w.document.write(image.outerHTML); ");
            }

            var messageNum: number | undefined = __chats.getLastMessageNo(data.chatId);
            messageNum = messageNum as number + 1;

            new MsgReceive({
                chatId: data.chatId,
                userId: data.senderId,   // must be a Unique ID for every user
                userName: data.snedername,
                userPhoto: data.senderImage,
                fragment: false,
                text: htmlDoc.body.innerHTML || ''
            });


            localStorage.removeItem(data.chatId);

            const chatQueue = __chatQueue.totalMsgs(data.chatId);
            window.parent.postMessage({
                'func': 'notificationNum',
                'message': 1
            }, "*");

            if (localStorage.getItem('widget_status' + window.location.search.substr(1).split("&")[0].split("=")[1]) === 'false') {
                setTimeout(() => {
                    __callbacks.continueConversation.trigger({
                        conversationId: data.chatId,
                        backState: AppState.home
                    });
                }, 100);

                sessionStorage.setItem('last_Chat' + window.location.search.substr(1).split("&")[0].split("=")[1], data.chatId);
            }

            setTimeout(() => {
                __sb.setMessageRead(data.chatId);
            }, 5000);

            __chatQueue.broadcastEvents(data.chatId);
        }

    }

    public setMessageRead(data: any) {
        var messageNum: number | undefined = __chats.getLastMessageNo(data.chatId);
    }

    public sendMessage(chatMessage: ChatMessage, messageText: String): string {
        const jsonData: any = {};

        jsonData.uid = __utils.getRandomIdShort();
        jsonData.chatId = chatMessage.chatId; // Use the chatId property directly
        jsonData.message = messageText;

        __ajax.sendAjaxRequest('post', '/chat/addMessage', JSON.stringify(jsonData), function (res: any) {
            //console.log(res);
        });

        return "";
    }

    public sendFile(chatMessage: IFileUpload): string {
        return "";
    }

    public sendSurvey(chatMessage: IChatMessage): string {
        return "";
    }

    public closeChat(chatMessage: IChatMessage): string {
        return "";
    }
}

export const __pusher = new pusherRoot();
